export default {
	en: {
		annotations: {
			pageSuggestions: "{count} suggestion | {count} suggestions",
			pageComments: "{count} comment | {count} comments",
		},
	},
};
